import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ClientModel } from "../../shared/entities/client.model";
import { PurchasedPackModel } from "../../shared/entities/purchased-pack.model";
import { ClientModelService } from "../services/client-model/client-model.service";

@Injectable()
export class ClientModelRepository {
	constructor(private client_model_service: ClientModelService) {}

	public getAdminClientActiveProducts(id?: string): Observable<Array<PurchasedPackModel>> {
		return this.client_model_service.getAdminClientActiveProducts(id).pipe(
			map((response: { data: PurchasedPackModel[] }) => {
				if (Array.isArray(response.data) && response.data.length > 0) {
					return response.data.map((element) => {
						return new PurchasedPackModel().deserialize(element);
					});
				}
				return [];
			}),
			catchError(() => {
				return observableOf([]);
			}),
		);
	}
	public cancelPurchasedPack(purchased_pack_id?: string): Observable<Array<any>> {
		return this.client_model_service.cancelPurchasedPack(purchased_pack_id).pipe(
			map((data: any) => {
				if (data) {
					return data;
				}
				return [];
			}),
			catchError(() => {
				return observableOf([]);
			}),
		);
	}

	public cancelRenewPurchasedPack(id?: string, renew?: boolean): Observable<Array<any>> {
		return this.client_model_service.cancelReNewPurchasedPack(id, renew).pipe(
			map((data: any) => {
				if (data) {
					return data;
				}
				return [];
			}),
			catchError(() => {
				return observableOf([]);
			}),
		);
	}

	public cancelAutoRenewalPurchasedPack(id?: string, renew?: boolean): Observable<Array<any>> {
		return this.client_model_service.cancelAutoRenewalPurchasedPack(id, renew).pipe(
			map((data: any) => {
				if (data) {
					return data;
				}
				return [];
			}),
			catchError(() => {
				return observableOf([]);
			}),
		);
	}

	public cancelPaidSale(id?: string, paid?: boolean): Observable<Array<any>> {
		return this.client_model_service.cancelPaidSale(id, paid).pipe(
			map((data: any) => {
				if (data) {
					return data;
				}
				return [];
			}),
			catchError(() => {
				return observableOf([]);
			}),
		);
	}

	public cancelTransaction(orderId: string): Observable<unknown> {
		return this.client_model_service.cancelTransaction(orderId);
	}

	public cancelSubscription(purchaseId: string) {
		return this.client_model_service.cancelPurchasedPack(purchaseId);
	}

	public cancelLicense(purchasedPackId: string): Observable<any> {
		return this.client_model_service.cancelLicense(purchasedPackId);
	}

	public markAsPaid(id?: string, body?: { orderId: string }): Observable<{ data: { message: string; object: PurchasedPackModel } }> {
		return this.client_model_service.markAsPaid(id, body).pipe(
			map((data: { message: string; object: PurchasedPackModel }) => {
				if (data) return data;
				return [];
			}),
			catchError((data) => {
				return observableOf(data);
			}),
		);
	}

	public getAdminClientById(id?: string): Observable<ClientModel> {
		return this.client_model_service.getAdminClientModelById(id).pipe(
			map((data: any) => {
				return new ClientModel().deserialize(data);
			}),
			catchError(() => {
				return observableOf(null);
			}),
		);
	}

	public getTaxValue(id: string): Observable<{ taxValue: number }> {
		return this.client_model_service.getTaxValue(id);
	}
}
